import { observer } from 'mobx-react-lite';
import { Play } from 'models/tagging/Play';
import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import { intToOrdinalNumberString } from 'services/helper-services/utils';
import { SectionHeader } from '../../SectionHeader/SectionHeader';
import { InningWrapper } from './InningSectionStyles';
import { PlaceholderPlay } from './PlaceholderPlay/PlaceholderPlay';
import { PlayComponent } from './Play/PlayComponent';

export interface IProps {
  number: number;
  isTop: boolean;
  plays: Play[];
  isInitiallyCollapsed: boolean;
  onPlaySelected: (play: Play) => void;
  selectedPlayObjectId?: string;
  shouldDisplayPlaceholder: boolean;
}
export const InningSection: React.FC<IProps> = observer((props: IProps) => {
  const { plays, number, isInitiallyCollapsed, onPlaySelected, selectedPlayObjectId, isTop, shouldDisplayPlaceholder } = props;
  const [isOpened, setIsOpened] = useState<boolean>(!isInitiallyCollapsed);

  const renderPlay = (play: Play, index: number) => {
    if (play.isPlaceholder) {
      return (
        <PlaceholderPlay
          key={index}
          isHidden={!shouldDisplayPlaceholder}
          batter={play.batter.nameRef}
          play={play}
          onClick={onPlaySelected}
          isSelected={!!selectedPlayObjectId && play.id === selectedPlayObjectId}
        />
      );
    }
    return <PlayComponent play={play} key={play.id} onClick={onPlaySelected} isSelected={play.id === selectedPlayObjectId} />;
  };
  return (
    <InningWrapper>
      <div data-testid={'inning-tile'}>
        <SectionHeader
          title={`${isTop ? 'Top' : 'Bottom'} ${intToOrdinalNumberString(number)} inning`}
          isExpandable
          onClickExpandIconCallback={() => setIsOpened(!isOpened)}
          iconClassName={isOpened ? 'expanded' : ''}
        />
      </div>
      <Collapse isOpened={isOpened}>{plays.map(renderPlay)}</Collapse>
    </InningWrapper>
  );
});
